"use client";
import {createContext, useContext, useMemo, BaseSyntheticEvent} from 'react';
import posthog from 'posthog-js';
import { PostHogProvider } from '@posthog/react'

const isDev = process.env.NEXT_PUBLIC_NODE_ENV !== "production";
const isKick = !process.env.NEXT_PUBLIC_PLATFORM || process.env.NEXT_PUBLIC_PLATFORM === 'kick';
const isRumble = !process.env.NEXT_PUBLIC_PLATFORM || process.env.NEXT_PUBLIC_PLATFORM === 'rumble';

interface Monitoring {
    track: (event: string, properties?: Record<string, any>) => void;
    updateUser: (user: Record<string, any>) => void;
    onClickTrack: (event: string, properties?: Record<string, any>) => (event: BaseSyntheticEvent) => void;
}

const DEFAULT_MONITORING: Monitoring = {
    track: () => {
    },
    updateUser: () => {
    },
    onClickTrack: () => () => {
    }
};

const MonitoringContext = createContext<Monitoring>(DEFAULT_MONITORING);

function findUiPosition(element: HTMLElement) {
    let currentElement: HTMLElement | null = element;
    while (currentElement) {
        if (currentElement.dataset.ui) {
            return currentElement.dataset.ui;
        }
        currentElement = currentElement.parentElement;
    }
    return ''
}

export function MonitoringProvider({children}) {
    const api = useMemo(() => {
        return {
            track: (event: string, properties: Record<string, any> = {}) => {
                posthog.capture(event, properties);
                isDev && console.log('track', event, properties);
            },
            onClickTrack: (eventName: string, customProps = {}) => (event: BaseSyntheticEvent) => {
                setTimeout(() => {
                    const uiPosition = findUiPosition(event.target)
                    api.track(`${eventName} Clicked`, {
                        ...customProps,
                        ui_position: uiPosition,
                        page: window.location.pathname
                    })
                    posthog.capture(`${eventName} Clicked`, {
                        ...customProps,
                        ui_position: uiPosition,
                        page: window.location.pathname
                    })
                }, 0)
            },
            updateUser: (userData: Record<string, any>) => {
                posthog.setPersonProperties(
                    userData
                );
            },
        };
    }, []);

    return (<PostHogProvider client={posthog}>
        <MonitoringContext.Provider value={(isKick || isRumble) ? api : DEFAULT_MONITORING}>
            {children}
        </MonitoringContext.Provider></PostHogProvider>
    );
}

export const useMonitoring = () => {
    return useContext(MonitoringContext);
};
